import { skipToken } from "@reduxjs/toolkit/query";
import {
  SlideoverDialog,
  SlideoverDialogContent,
  SlideoverDialogHeader,
} from "@repo/ui/Slideover/slideoverDialog";
import type { FC } from "react";
import { Heading } from "react-aria-components";
import { Outlet, useParams } from "react-router";
import { useGetPlaybookTestSpecQuery } from "../../api/entities/playbookTestSpec.js";
import { useGetTeammateAgentQuery } from "../../api/entities/teammateAgent.js";
import {
  TabsLayoutTab,
  TabsLayoutTabs,
} from "../../components/layout/tabsLayout.js";

export const TeammateAgentResultOverview: FC = () => {
  const { teammateAgentId, testSpecId } = useParams();
  if (!teammateAgentId || !testSpecId) {
    throw new Error("Missing params.");
  }

  const { data: teammateAgent } = useGetTeammateAgentQuery(teammateAgentId);
  const playbookId = teammateAgent?.teammate_agent_config.playbook_id;

  // Fetch the specific test spec
  const { data: playbookTestSpec, isLoading } = useGetPlaybookTestSpecQuery(
    playbookId ? { playbookId, testSpecId } : skipToken,
  );

  const renderDialogLabel = () => {
    if (!playbookTestSpec) {
      return "Loading test spec...";
    }

    return `Test: ${playbookTestSpec.name}`;
  };

  const renderHeaderLeft = () => {
    if (!playbookTestSpec) {
      return null;
    }

    return (
      <div className="flex min-w-0 flex-col">
        <div className="flex min-w-0 items-center gap-1">
          <Heading
            slot="title"
            className="truncate text-base font-semibold text-foreground"
          >
            {playbookTestSpec.name}
          </Heading>
        </div>
        {playbookTestSpec.description && (
          <div className="truncate text-xs text-gray-600">
            {playbookTestSpec.description}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <SlideoverDialog label={renderDialogLabel()}>
        <SlideoverDialogHeader isLoading={isLoading}>
          {renderHeaderLeft()}
          <TabsLayoutTabs isLoading={isLoading}>
            <TabsLayoutTab to="assessment">Assessment</TabsLayoutTab>
            <TabsLayoutTab to="transcript">Transcript</TabsLayoutTab>
          </TabsLayoutTabs>
        </SlideoverDialogHeader>
        <SlideoverDialogContent>
          <Outlet />
        </SlideoverDialogContent>
      </SlideoverDialog>
    </>
  );
};
